// Strip HTML to plain text for compact table / preview rendering (ported from legacy
// `composables/format.js` L2161–2182). Sharpened: the `document.createElement`
// dependency is guarded so this is safe in a no-DOM (SSR / unit) context.

const BLOCK_CLOSE_RE = /<\/(p|div|h[1-6]|li|tr|blockquote)>/gi
const BR_RE = /<br\s*\/?>/gi
const ANY_TAG_RE = /<[^>]*>/g
const WHITESPACE_RE = /\s+/g

/**
 * Convert rich-text HTML to a single line of plain text: line-break and block-close
 * tags become spaces, remaining markup is removed, and whitespace is collapsed.
 *
 * Uses a detached DOM element to decode entities when a DOM is available (the input
 * is never inserted into the document, so no scripts/resources run), and falls back
 * to a pure regex strip in a no-DOM environment.
 */
export function stripHtml(html: unknown): string {
  if (!html) return ''
  if (typeof html !== 'string') return String(html)

  let text = html.replace(BR_RE, ' ')
  text = text.replace(BLOCK_CLOSE_RE, ' ')

  if (typeof document === 'undefined' || typeof document.createElement !== 'function') {
    // No-DOM (SSR / unit) fallback: strip any remaining tags without entity decoding.
    return text.replace(ANY_TAG_RE, '').replace(WHITESPACE_RE, ' ').trim()
  }

  const tmp = document.createElement('div')
  tmp.innerHTML = text
  return (tmp.textContent ?? '').replace(WHITESPACE_RE, ' ').trim()
}
